const Footer=()=>{
    return(
        <div class="tiktok-857ltq-DivBottomContainer etab5w61">
            <div class="tiktok-12qkzgl-DivContainer e9zvghz0">
                <p class="tiktok-uqz62q-PSelectContainer e9zvghz1">
                    <span>English</span>
                </p>
                <select class="tiktok-vm0biq-SelectFormContainer e9zvghz2">
                        <option value="ar">العربية</option>
                        <option value="bn-IN">বাঙ্গালি (ভারত)</option>
                        <option value="ceb-PH">Cebuano (Pilipinas)</option>
                        <option value="cs-CZ">Čeština (Česká republika)</option>
                        <option value="de-DE">Deutsch</option>
                        <option value="el-GR">Ελληνικά (Ελλάδα)</option>
                        <option selected="" value="en">English</option>
                        <option value="es">Español</option>
                        <option value="fi-FI">Suomi (Suomi)</option>
                        <option value="fil-PH">Filipino (Pilipinas)</option>
                        <option value="fr">Français</option>
                        <option value="he-IL">עברית (ישראל)</option>
                        <option value="hi-IN">हिंदी</option>
                        <option value="hu-HU">Magyar (Magyarország)</option>
                        <option value="id-ID">Bahasa Indonesia (Indonesia)</option>
                        <option value="it-IT">Italiano (Italia)</option>
                        <option value="ja-JP">日本語（日本）</option>
                        <option value="jv-ID">Basa Jawa (Indonesia)</option>
                        <option value="km-KH">ខ្មែរ (កម្ពុជា)</option>
                        <option value="ko-KR">한국어 (대한민국)</option>
                        <option value="ms-MY">Bahasa Melayu (Malaysia)</option>
                        <option value="my-MM">မြန်မာ (မြန်မာ)</option>
                        <option value="nl-NL">Nederlands (Nederland)</option>
                        <option value="pl-PL">Polski (Polska)</option>
                        <option value="pt-BR">Português (Brasil)</option>
                        <option value="ro-RO">Română (Romania)</option>
                        <option value="ru-RU">Русский (Россия)</option>
                        <option value="sv-SE">Svenska (Sverige)</option>
                        <option value="th-TH">ไทย (ไทย)</option>
                        <option value="tr-TR">Türkçe (Türkiye)</option>
                        <option value="uk-UA">Українська (Україна)</option>
                        <option value="ur">اردو</option>
                        <option value="vi-VN">Tiếng Việt (Việt Nam)</option>
                        <option value="zh-Hans">简体中文</option>
                        <option value="zh-Hant-TW">繁體中文</option>
                </select>
            </div>
            <div class="tiktok-tljvws-DivCopyright etab5w62">© 2022 TikTok</div>
        </div>  
    )
}
export default Footer